import * as React from "react";
import {section__desc as sectionDescription} from "./section.module.css";

const SectionDescription = ({children: content}) => {
    return <p className={sectionDescription}>{content}</p>;
};

export default SectionDescription;
